// Angular Core Modules
import { NgModule } from "@angular/core";
import { CtaButtonGroupComponent } from "./components/buttons/cta-button-group/cta-button-group.component";
import { DodoComponentsCommonModule } from "./dodo-components-common.module";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";

// Directives
export const components = [CtaButtonGroupComponent];

@NgModule({
	imports: [CommonModule, DodoComponentsCommonModule, MatButtonModule],
	declarations: [...components],
	exports: [...components, DodoComponentsCommonModule]
})
export class DodoComponentsModule {}
